import React from 'react';
import Typed from 'react-typed';
import {Link} from "react-router-dom";


const IntroThree = () => {
    return (
        <div className="intro-section section overlay" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/hero-image/hero-4.jpg)`}}>

            <div className="container">
                <div className="row row-cols-lg-1 row-cols-1">

                    <div className="col align-self-center">
                        <div className="intro-content-two headline-active text-center mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
                            <h2 className="title ah-headline">Criando {" "} 
                            <Typed
                                strings={[
                                    ' impressionantes ',
                                    ' maravilhosas ',
                                    ' bonitas ']}
                                    typeSpeed={100}
                                    backSpeed={110}
                                    loop  /> marcas &amp; experiências </h2>
                            <div className="desc">
                                <p>Somos uma empresa localizada no Brasil. Pensamos em estratégia, criamos design, 
                                    desenvolvemos digital e criamos movimento. Para encaminhar sua marca e negócio.</p>
                            </div>
                            <Link to={process.env.PUBLIC_URL + "/"} className="btn btn-primary btn-hover-secondary">Comece</Link>
                            <Link to={process.env.PUBLIC_URL + "/"} className="btn btn-outline-white btn-hover-primary"> Saber mais </Link>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default IntroThree
